import { defineStore } from 'pinia'
import apiService from '../services/apiService'
import logService from '../services/logService'

export const useLegalPagesStore = defineStore('legalPages', {
  state: () => ({
    legalPages: [],
    currentPage: null,
    loading: false,
    error: null
  }),

  getters: {
    getLegalPageBySlug: (state) => (slug) => {
      return state.legalPages.find(page => page.slug === slug)
    },

    isLoading: (state) => state.loading,

    hasError: (state) => state.error !== null
  },

  actions: {
    async fetchAllLegalPages() {
      this.loading = true
      this.error = null
      logService.info('Fetching all legal pages...')

      try {
        const response = await apiService.get('/legal-pages')

        if (response.success) {
          this.legalPages = response.data
        }
      } catch (error) {
        logService.error('Fetch Legal Pages Error:', error)
        this.error = error.message
      } finally {
        this.loading = false
      }
    },

    async fetchLegalPage(slug) {
      this.loading = true
      this.error = null
      logService.info(`Fetching legal page: ${slug}`)

      try {
        const response = await apiService.get(`/legal-pages/${slug}`)

        if (response.success) {
          this.currentPage = response.data

          // Also update in the list if it exists
          const index = this.legalPages.findIndex(page => page.slug === slug)
          if (index !== -1) {
            this.legalPages[index] = response.data
          } else {
            this.legalPages.push(response.data)
          }

          return response.data
        }
      } catch (error) {
        logService.error(`Fetch Legal Page Error [${slug}]:`, error)
        this.error = error.message
        return null
      } finally {
        this.loading = false
      }
    },

    clearCurrentPage() {
      this.currentPage = null
    },

    clearError() {
      this.error = null
    }
  }
})
